










import {Vue, Component} from 'vue-property-decorator';
import InspectionThirdStep from './InspectionThirdStep.vue';
import InspectionSecondStep from './InspectionSecondStep.vue';

@Component({
  components: {
    InspectionSecondStep,
    InspectionThirdStep,
  },
})
export default class InspectionFourthStep extends Vue {}
